import '../shared-types'

import cx from 'classnames'
import * as React from 'react'

import { isBlank } from '@mondough/utils/formatting'

import type { Colors } from '../shared-types'
import styles from './dialog.module.scss'

interface Props<C extends React.ElementType> {
  is?: C
  withSeparator?: boolean
  className?: string
  children: React.ReactNode
  backgroundColor?: 'primary' | 'secondary' | Colors
}

type DialogFooterProps<C extends React.ElementType> = Props<C> &
  Omit<React.ComponentPropsWithoutRef<C>, keyof Props<C>>

export default function DialogFooter<C extends React.ElementType>({
  className,
  children,
  is,
  withSeparator = false,
  backgroundColor,
}: DialogFooterProps<C>) {
  const Component = is || 'footer'
  return (
    <Component
      className={cx(
        styles.footerSection,
        {
          [styles.withFooterBorder]: withSeparator,
          [styles[`background-${backgroundColor ?? ''}`]]:
            !isBlank(backgroundColor),
        },

        className,
      )}
    >
      {children}
    </Component>
  )
}
